import apiClient from '@/services/api'

export default {
  async deletePayCode({ commit, rootState, dispatch }, { pay_code_id }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/pay_code/delete', {
        project_id: rootState.applicationState.currentProject.id,
        pay_code_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const updatedPayCodes = rootState.applicationState.projectPayCodes.filter(payCode => payCode.id !== pay_code_id)

      commit('setProjectPayCodes', updatedPayCodes, { root: true })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })
    } catch (error) {
      throw error.message
    }
  },

  async updatePayCode({ commit, rootState, dispatch }, { pay_code }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      if (!pay_code.id) {
        throw new Error('An error occurred while editing the pay code. ')
      }

      const { data } = await apiClient.post('/api/project/pay_code/update', {
        project_id: rootState.applicationState.currentProject.id,
        pay_code
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const updatedPayCodes = rootState.applicationState.projectPayCodes.map(payCode =>
        payCode.id === pay_code.id ? { ...payCode, ...data.pay_code } : payCode
      )

      commit('setProjectPayCodes', updatedPayCodes, { root: true })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })
    } catch (error) {
      throw error.message
    }
  },

  async createPayCode({ commit, rootState, dispatch }, { pay_code }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/pay_code/create', {
        project_id: rootState.applicationState.currentProject.id,
        pay_code
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const updatedPayCodes = [data.pay_code, ...rootState.applicationState.projectPayCodes]

      commit('setProjectPayCodes', updatedPayCodes, { root: true })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })
    } catch (error) {
      throw error.message
    }
  },

  async fetchPayCode({ commit, rootState }, { pay_code_id }) {
    try {
      const { data } = await apiClient.post('/api/project/pay_code/get', {
        project_id: rootState.applicationState.currentProject.id,
        pay_code_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setPayCode', data.pay_code)
    } catch (error) {
      throw error.message
    }
  }
}
